import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      allowMultiLoading: false,
      // Force the browser to revalidate locale files on every load. Without
      // this, a copy cached before a new namespace key was added stays
      // "heuristically fresh" and is served without revalidation, so newly
      // added keys (e.g. errors.licenseExpired) never reach i18next and the
      // raw key string leaks into the UI.
      requestOptions: { cache: "no-cache" },
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "language",
      caches: ["localStorage"],
      excludeCacheFor: ["cimode"],
      // Normalize detected codes to a locale directory that actually exists
      // under /public/locales (en, zh, zh_CN, jp, ko). Browser navigator codes
      // carry a region (e.g. "en-US", "zh-CN", "ja-JP") that would otherwise
      // request a non-existent folder and fall through to the SPA index.html,
      // leaving every namespace empty and surfacing raw i18n keys in the UI.
      convertDetectedLanguage: (lng: string) => {
        const supported = ["en", "zh", "zh_CN", "jp", "ko"];
        if (supported.includes(lng)) return lng;
        // "zh-CN" -> "zh_CN" (file uses underscore)
        const underscored = lng.replace(/-/g, "_");
        if (supported.includes(underscored)) return underscored;
        // Strip region: "en-US" -> "en", "zh-TW" -> "zh", "ja-JP" -> "ja"
        const base = lng.split(/[-_]/)[0].toLowerCase();
        const baseAlias: Record<string, string> = { ja: "jp" };
        const mapped = baseAlias[base] ?? base;
        return supported.includes(mapped) ? mapped : "en";
      },
    },

    ns: [
      "common",
      "header",
      "sidebar",
      "home",
      "login",
      "settings",
      "pipeline-studio",
      "plans",
      "table",
      "notFound",
    ],
    defaultNS: "common",
  });

export default i18n;
